import {Link} from "react-router-dom";
import {Tooltip, Flex, Tag} from "antd";
import {AiFillPushpin} from "react-icons/ai";
import {RiPushpin2Fill} from "react-icons/ri";
import {TbMapPinPin, TbMapPinFilled} from "react-icons/tb";
import styles from './CompaniesColumns.module.scss';
import {
    companyTypeFilters,
    renderCompanyTypeTag
} from "../../utils/company/company_type";
import {images} from "../../constants";


const CompaniesColumns = (t, handleChangePeriod, handleSaveCompany, handleDeleteSaveCompany, getColorBySoftwareName, softwareData, totalDeviceCount) => {
    return [
        {
            title: t('pages.companies.listColumns.column6'),
            key: "is_saved",
            render: (_, record) => (
                <Tooltip key={record.id} title="Pin Company">
                    {record.is_saved ? (
                        <RiPushpin2Fill
                            size={18}
                            className={styles.heartIconSaved}
                            onClick={() => handleDeleteSaveCompany(record, false)}
                        />
                    ) : (
                        <AiFillPushpin
                            size={18}
                            className={styles.heartIcon}
                            onClick={() => handleSaveCompany(record, false)}
                        />
                    )}
                </Tooltip>
            )
        },
        {
            title: t('pages.companies.listColumns.column6'),
            key: "is_all_market_saved",
            render: (_, record) => (
                <Tooltip key={record.id} title="Pin all Market of Company">
                    {record.is_all_market_saved ? (
                        <TbMapPinFilled
                            color="#017bfe"
                            size={18}
                            onClick={() => handleDeleteSaveCompany(record, true)}
                        />
                    ) : (
                        <TbMapPinPin
                            color="#808080"
                            size={18}
                            onClick={() => handleSaveCompany(record, true)}
                        />
                    )}
                </Tooltip>
            )
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.companies.listColumns.column1')}
                </span>
            ),
            dataIndex: 'company_name',
            sorter: false,
            render: (text, record) => (
                <Link to={`/company/detail/${record.key}`}>{text}</Link>
            ),
            width: 300,
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.companies.listColumns.column7')}
                </span>
            ),
            dataIndex: 'public_name',
            render: (text, record) => (
                <Link to={`/company/detail/${record.key}`}>{text}</Link>
            ),
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.companies.listColumns.column2')}
                </span>
            ),
            dataIndex: 'company_inn',
            sorter: false,
            render: (text, record) => (
                <Link to={`/company/detail/${record.key}`}>{text}</Link>
            ),
        },
        {
            title: (
                <>
                    {t('pages.companies.listColumns.column10')}
                    <span style={{fontWeight: 'normal', color: '#999'}}>
                        {' '}({totalDeviceCount})
                    </span>
                </>
            ),
            dataIndex: 'company_active_device_count',
            sorter: true,
            orderIndex: "company_active_device_count",
            render: (text, record) => (
                <Tag
                    icon={
                        <img
                            src={images.fiscalboxDeviceCount}
                            alt="icon"
                            style={{
                                width: 14,
                                height: 14,
                                marginRight: 4,
                                marginBottom: 2,
                                verticalAlign: 'middle',
                            }}
                        />
                    }
                    color="default"
                >
                    {record.company_total_device_count} / {text}
                </Tag>
            )
        },
        {
            key: 'company_type',
            title: t('pages.companies.listColumns.column8'),
            dataIndex: 'company_type',
            filters: companyTypeFilters,
            filterDropdown: false,
            filterMultiple: false,
            filterSearch: true,
            render: (value) => renderCompanyTypeTag(value),
        },
        {
            title: t('pages.companies.listColumns.column9'),
            dataIndex: 'softwares',
            key: 'software',
            filters: softwareData,
            filterMultiple: false,
            filterSearch: true,
            render: (softwareList) => (
                <Flex gap="4px 0" wrap="wrap">
                    {softwareList && softwareList.length > 0 ? (
                        softwareList.map((item, index) => (
                            <Tag key={index} color={getColorBySoftwareName(item.name)}>
                                {item.name}
                            </Tag>
                        ))
                    ) : (
                        <span>-</span>
                    )}
                </Flex>
            ),
        },
        {
            title: t('pages.companies.listColumns.column3'),
            dataIndex: 'company_address',
            orderIndex: "address",
            width: 500
        },
        // {
        //     title: t('pages.companies.listColumns.column4'),
        //     dataIndex: 'current_month_sms_count',
        //     // sorter: true,
        //     sorter: (a, b) => a.current_month_sms_count - b.current_month_sms_count,
        //     orderIndex: "current_month_sms_count",
        //     filterDropdown: () => (
        //         <div style={{padding: 8}}>
        //             <RangePicker
        //                 presets={usePeriodPresets}
        //                 onChange={handleChangePeriod}
        //                 disabledDate={disabledDate}
        //                 allowClear={true}
        //                 style={{marginBottom: 16}}
        //                 placeholder={[`${t("common.filter.dateFilter1")}`, `${t("common.filter.dateFilter2")}`]}
        //             />
        //         </div>
        //     ),
        // },
        {
            title: t('pages.companies.listColumns.column5'),
            dataIndex: 'company_phone_number',
            orderIndex: "phone_number",
            render: (phone) => (
                <a href={`tel:${phone}`} onClick={(e) => e.stopPropagation()}>
                    {phone}
                </a>
            ),
        },
    ];
};

export default CompaniesColumns;
